import { Column } from "../../../../components/TableDataGridV2/types";
import { IDataListaTitulosReceber } from "../../../../types/api/financeiro/pesquisar-titulos-receber";

export const colunas: Column<IDataListaTitulosReceber>[] = [
    {
        id: 'id',
        label: 'Título',
        type: "text",
        numeric: false,
        sortable: false,
        minWidth: 120,
    },
    {
        id: 'data_emissao',
        label: 'Emissão',
        type: "date",
        numeric: false,
        sortable: true,
        minWidth: 120,
    },
    {
        id: 'data_vencimento',
        label: 'Vencimento',
        type: "date",
        numeric: false,
        filter: true,
        sortable: true,
        minWidth: 120,
    },
    {
        id: 'boleto',
        label: 'Sit. Boleto',
        type: "chip",
        numeric: false,
        filter: false,
        sortable: false,
        minWidth: 120,
        condition: (value) => value === 'Sem boleto'
    },
    {
        id: 'valor_receber',
        label: 'Valor original',
        type: "monetary",
        numeric: true,
        filter: true,
        sortable: true,
        minWidth: 100,
    },
    {
        id: 'saldo_principal',
        label: 'Saldo Principal',
        type: "monetary",
        numeric: true,
        filter: true,
        sortable: true,
        minWidth: 100,
    },
    {
        id: 'saldo_simulado',
        label: 'Saldo simulado',
        type: "monetary",
        numeric: true,
        filter: false,
        sortable: false,
        minWidth: 100,
    },
    {
        id: 'tipo_publico',
        label: 'Público',
        type: "text",
        numeric: false,
        filter: true,
        sortable: true,
        minWidth: 100,
    },
    {
        id: 'codigo_publico',
        label: 'Código',
        type: "text",
        numeric: false,
        filter: true,
        sortable: true,
        minWidth: 100,
    },
    {
        id: 'nome_publico',
        label: 'Nome',
        type: "text",
        numeric: false,
        filter: true,
        sortable: false,
        minWidth: 150,
    },
    {
        id: 'comprador',
        label: 'Comprador',
        type: "text",
        numeric: false,
        filter: true,
        sortable: true,
        minWidth: 150,
    },
    {
        id: 'numero_nf',
        label: 'NF',
        type: "text",
        numeric: false,
        filter: true,
        sortable: true,
        minWidth: 100,
    },
    {
        id: 'historico',
        label: 'Histórico',
        type: "text",
        numeric: false,
        filter: true,
        sortable: true,
        minWidth: 200,
    },
    {
        id: 'data_recebimento',
        label: 'Data recebimento',
        type: "date",
        numeric: false,
        filter: true,
        sortable: true,
        minWidth: 120,
    },
    {
        id: 'departamento',
        label: 'Departamento',
        type: "text",
        numeric: false,
        filter: true,
        sortable: false,
        minWidth: 150,
    },
    {
        id: 'funcao',
        label: 'Função',
        type: "text",
        numeric: false,
        filter: false,
        sortable: true,
        minWidth: 150,
    },
    {
        id: 'descricao_tipo',
        label: 'Descrição do tipo',
        type: "text",
        numeric: false,
        filter: false,
        sortable: false,
        minWidth: 200,
    },
    {
        id: 'consome_limite_credito',
        label: 'Consome limite crédito?',
        type: "text",
        numeric: false,
        filter: false,
        sortable: false,
        minWidth: 200,
    },
];

export const headCells = colunas.filter(cell => cell.id !== 'saldo_simulado');
export const headCellsRecebimento = colunas.filter(cell => cell.id !== 'data_recebimento' && cell.id !== 'saldo_simulado');
export const headCellsRecbCompensacao = colunas.filter(cell => cell.id !== 'data_recebimento');
